
export const GlobalStyles = palette => ({
    '*': {
        boxSizing: 'border-box'
    },
    html: {
        WebkitOverflowScrolling: 'touch',
    },
    body: {
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        minHeight: "100vh"
    },
    input: {
        '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
                margin: 0,
                WebkitAppearance: 'none'
            },
            '&::-webkit-inner-spin-button': {
                margin: 0,
                WebkitAppearance: 'none'
            }
        }
    },
    img: {
        display: 'block',
        maxWidth: '100%'
    },
    ul: {
        margin: 0,
        padding: 0
    },

    // Cascader Styles
    ".rs-picker-cascader": {
        ".rs-picker-value-count": {
            backgroundColor: palette.primary.main
        }
    },

    ".rs-picker-cascader-menu-items": {
        ".rs-check-item": {
            backgroundColor: palette.background.paper,

            svg: {
                color: palette.text.disabled
            },

            "&.rs-check-item-focus, &:hover": {
                backgroundColor: palette.primary.lighter || palette.primary.light,

                ".rs-checkbox-inner:before, .rs-checkbox-wrapper:before": {
                    border: `1px solid ${palette.primary.main}`
                },

                svg: {
                    color: palette.text.primary
                }
            },

            "&.rs-checkbox-checked, &.rs-checkbox-indeterminate": {
                ".rs-checkbox-inner:before, .rs-checkbox-wrapper:before": {
                    border: `1px solid ${palette.primary.main}`,
                    backgroundColor: palette.primary.main
                }
            }

        }
    },

    // Date Pickers & Range Picker (Calendar) Styles
    ".rs-picker-daterange-panel": {
        ".rs-picker-daterange-": {
            ".rs-btn": {
                color: palette.primary.main
            }
        },
    },

    ".rs-picker-menu, .rs-picker-popup": {
        zIndex: 1301,

        ".rs-calendar .rs-calendar-body .rs-calendar-table-cell": {
            "&:hover": {
                backgroundColor: palette.primary.lighter,

                ".rs-calendar-table-cell-content": {
                    backgroundColor: palette.primary.lighter,
                    color: palette.primary.main
                }
            },

            "&.rs-calendar-table-cell-is-today ": {
                "div[role='button']": {
                    boxShadow: `inset 0 0 0 1px ${palette.primary.main}`
                }
            },

            "&.rs-calendar-table-cell-selected": {
                div: {
                    backgroundColor: palette.primary.main
                }
            },

            "&.rs-calendar-table-cell-in-range": {
                backgroundColor: palette.primary.lighter,
                "&::before": {
                    backgroundColor: palette.primary.lighter
                }
            }
        },

        ".rs-calendar-header-title": {
            color: palette.text.primary
        },

        ".rs-calendar-time-dropdown-cell": {
            "&:hover": {
                backgroundColor: palette.primary.light,
                color: palette.primary.main
            },

            "&-active, &-active:hover": {
                backgroundColor: palette.primary.main,
                color: palette.primary.contrastText
            }
        },

        ".rs-picker-toolbar": {
            ".rs-picker-toolbar-ranges": {
                button: {
                    color: palette.primary.main
                }
            },

            ".rs-picker-toolbar-right": {
                button: {
                    backgroundColor: palette.primary.main,
                    "&:hover": {
                        backgroundColor: palette.primary.darker
                    }
                }
            }
        }
    }
})